import Event from '../../core/Event';

export default class UserChangePasswordRequested extends Event {
    public static type = 'UserChangePasswordRequested';

    constructor(public readonly password: string) {
        super(UserChangePasswordRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/user/events/UserChangePasswordRequested.ts